/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Entry/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Entry({
  children,
  viewPath = "/DesignSystem/PatientInformation/Content/PaymentOverdue/Content/Entry"
  
}) {
let entryDueValueData = fromData.useDataValue({ viewPath,
context: 'entry',
path: 'due',
})
let entryPaymentAccountValueData = fromData.useDataValue({ viewPath,
context: 'entry',
path: 'payment_account',
})
let entryItemIsLastValueData = fromData.useDataValue({ viewPath,
context: 'entry_item',
path: 'isLast',
})
let aggregateData = fromHelpers.getText(entryDueValueData, entryPaymentAccountValueData, entryItemIsLastValueData)
let entryItemIsLastValueData1 = fromData.useDataValue({ viewPath,
context: 'entry_item',
path: 'isLast',
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let entryTimeIntervalValueData = fromData.useDataValue({ viewPath,
context: 'entry',
path: 'time_interval',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let entryItemIsLastValueData2 = fromData.useDataValue({ viewPath,
context: 'entry_item',
path: 'isLast',
})
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<div
  data-testid="Entry.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 size="small"
 data="entry.due"
 data="entry.payment_account"
 data="entry_item.isLast"
 aggregate="helpers.js getText"
 text={aggregateData}
 marginRight={entryItemIsLastValueData1 ? "0px" : dtSpaceXxxs}
 data="entry_item.isLast"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXs}
 data="entry.time_interval"
 text={entryTimeIntervalValueData}
 size="tiny"
 color={dtColorsNeutral900}
/>
<fromFlow.When is={!entryItemIsLastValueData2}>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 text=","
 color={dtColorsNeutral400}
 data="entry_item.isLast"
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}